import {useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'

import {
	createClient,
} from '../users/usersSlice'

import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as faIcons  from '@fortawesome/free-solid-svg-icons'

import {getChatRooms} from '../MessageCenter/messageCenterSlice'

import {useHistory} from 'react-router-dom'

export default function AddClient ({location}) {
	const dispatch = useDispatch()
	const history = useHistory()

	const params = new URLSearchParams(location.search)
	const trainer = params.get('trainer')
	const trainerParam = (
		Boolean(trainer)
		? `&trainer=${trainer}`
		: ''
	)

	const [email,setEmail] = useState('')
	const [name,setName] = useState('')
	const [allowLogin,setAllowLogin] = useState(true)
	const [sendEmail,setSendEmail] = useState(true)
	const [password,setPassword] = useState('')

	const [hidePassword,setHidePassword] = useState(false)

	const [isSaving,setIsSaving] = useState(false)
	const handleSave = ()=>{
		if (!email&&allowLogin) {
			window.alert('Please provide an email')
			return 
		}
		if (!password&&allowLogin) {
			window.alert('Please provide a password')
			return 
		}
		if (!name) {
			window.alert('Please provide a name')
			return 
		}
		setIsSaving(true)
		dispatch(createClient({
			client_email:email,
			user_name:name,
			setup_account:Number(allowLogin),
			send_welcome_email:Number(sendEmail),
			client_password:password
		})).then(({payload})=>{
			setIsSaving(false)
			dispatch(getChatRooms())
			if(payload.success==='1'){
				history.push(`/clientEditor?clientId=${payload.data.client.user_id_number}${trainerParam}`)
			}else{
				window.alert(payload.message)
			}
		})
	}

	const isMAXUser = useSelector(state => Boolean(state.users?.current_user?.isMAXUser))
	return (
		<div className="pt-4 px-2 px-md-3">
			<Alert variant="info" className="text-dark">
				<FontAwesomeIcon icon={faIcons.faCircleInfo} className="mr-1"/>
				After creating this client you will be forwarded to an editor with more options.
			</Alert>
			<strong>
				Add {isMAXUser?'Member':'Client'}
			</strong>
			<hr/>
			<strong>
				Name
			</strong>
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>
						<FontAwesomeIcon icon={faIcons.faUser}/>
					</InputGroup.Text>
				</InputGroup.Prepend>
				<Form.Control 
					autocomplete="off"
					placeholder="Enter Name"
					value={name}
					onChange={e=>{
						setName(e.target.value)
					}}
				/>
			</InputGroup>
			{allowLogin&&
				<div>
					<strong>Email</strong>
					<InputGroup>
						<InputGroup.Prepend>
							<InputGroup.Text>
								<FontAwesomeIcon icon={faIcons.faAt}/>
							</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control 
							placeholder="email"
							value={email}
							onChange={e=>{
								setEmail(e.target.value)
							}}
						/>
					</InputGroup>
				</div>
			}
			{allowLogin&&
				<div>
					<strong>Password</strong>
					<InputGroup>
						<InputGroup.Prepend>
							<InputGroup.Text>
								<FontAwesomeIcon icon={faIcons.faLock}/>
							</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control 
							placeholder="password"
							value={password}
							type={hidePassword?'password':'text'}
							onChange={e=>{
								setPassword(e.target.value)
							}}
						/>
						<InputGroup.Append>
							<Button 
								onClick={setHidePassword.bind(null,p=>!p)}
								variant="outline-secondary"
							>
								<FontAwesomeIcon 
									icon={faIcons[hidePassword?'faEyeSlash':'faEye']}
								/>
							</Button>
						</InputGroup.Append>
					</InputGroup>
				</div>
			}
			<Form.Check 
				checked={allowLogin}
				onChange={e=>{
					setAllowLogin(e.target.checked)
				}}
				id="allow-login-switch"
				label="Enable Client to Login"
			/>
			<Form.Check 
				checked={sendEmail}
				onChange={
					e=>{
						setSendEmail(e.target.checked)
					}
				}
				id="send-email-switch"
				label="Send Automated Welcome Email"
			/>
			<Button 
				onClick={handleSave}
				variant="outline-success" 
				className="mt-2"
				disabled={isSaving}
				block
			>
				Add {isSaving&&<Spinner animation="border" size="sm"/>}
			</Button>
		</div>
	)
}